import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCaretLeft,
    faUsersGear,
    faUserShield,
    faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { ReflexContainer, ReflexElement } from 'react-reflex';
import { Button, Modal } from '@quyva/shared-ui';
import { Brand } from '../brand';
import { UserDetailAndAction } from '../userDetailAndAction';
import AgentToolToggle from './agentToolToggle';
import ToolsListCollection from '../toolsSection/ToolsListCollection';
import AddAgentView from './addAgentView';

const AgentToolSideBar = ({
    setIsSideViewExpanded,
    planName,
    activeView,
    setActiveView,
    tools,
    selectedToolId,
    onSelectTool,
    user,
    onAddInstance, // Callback from agentToolView to open AddInstanceDialog
    agentList,
    getAgentList
}) => {
    const [addAgent, setAddAgent] = useState(false);

    const toolsForCollection = [{ id: 'all', name: 'All' }, ...tools];

    return (
        <div className='z-0 h-full w-full p-1 m-0 rounded-xl'>
            <ReflexContainer orientation='horizontal'>
                <ReflexElement
                    className='header border-b-2 border-b-backgrounds-white'
                    style={{
                        minHeight: '8rem',
                        height: '8rem',
                        maxHeight: '8rem',
                    }}
                >
                    <div className='pane-content w-full h-full pb-2 px-1'>
                        <div className='w-full h-full flex flex-col justify-between items-center text-texts-secondary300'>
                            <Brand />
                            <div className='w-full flex items-center justify-between'>
                                <div className='pane-content p-1'>
                                    <div className='w-full flex justify-center'>
                                        <AgentToolToggle
                                            activeView={activeView}
                                            setActiveView={setActiveView}
                                        />
                                    </div>
                                </div>
                                <Button
                                    icon={faCaretLeft}
                                    className={'w-9 h-9 text-icons-primary'}
                                    onClick={() => setIsSideViewExpanded(false)}
                                    hoverText={'Collapse Sidebar'}
                                    type={'warning'}
                                />
                            </div>
                        </div>
                    </div>
                </ReflexElement>
                {activeView === 'agents' ? (
                    <ReflexElement flex={1}>
                        <div>
                            {activeView === 'agents' && (
                                <div className='w-full text-texts-secondary300 mt-4'>
                                    <div className='w-full flex items-center justify-between py-2 px-2 bg-backgrounds-primary100 border border-backgrounds-primary200 shadow-inner rounded-xl'>
                                        <div className='flex items-center'>
                                            <div className='w-8 h-8 rounded-full bg-white flex items-center justify-center mr-2'>
                                                <FontAwesomeIcon
                                                    icon={faUserShield}
                                                    className='text-backgrounds-primary300'
                                                />
                                            </div>
                                            <span className='text-base text-backgrounds-primary300'>
                                                ALL Agents
                                            </span>
                                        </div>
                                        <Button
                                            icon={faPlus}
                                            className={
                                                'w-9 h-9 text-icons-primary'
                                            }
                                            onClick={() => setAddAgent(true)}
                                            hoverText={'Add Agent'}
                                            type={'success'}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </ReflexElement>
                ) : (
                    <ReflexElement flex={1}>
                        <div className='pane-content p-1 h-full overflow-auto'>
                            <ToolsListCollection
                                tools={toolsForCollection}
                                selectedToolId={selectedToolId}
                                onSelectTool={onSelectTool}
                                onAddInstance={onAddInstance}
                            />
                        </div>
                    </ReflexElement>
                )}

                <ReflexElement
                    className='footer border-t-2 border-t-backgrounds-white'
                    style={{
                        minHeight: '7rem',
                        height: '7rem',
                        maxHeight: '7rem',
                    }}
                >
                    <div className='pane-content w-full h-full'>
                        <UserDetailAndAction planName={planName} />
                    </div>
                </ReflexElement>
            </ReflexContainer>
            {addAgent && (
                <Modal
                    title='Add New Agent'
                    titleIcon={faUsersGear}
                    onClose={() => setAddAgent(false)}
                >
                    <AddAgentView
                        setAddMode={setAddAgent}
                        user={user}
                        agentList={agentList}
                        getAgentList={getAgentList}
                    />
                </Modal>
            )}
        </div>
    );
};

export default AgentToolSideBar;
